<template>
  <div class="platDiagnosis">
    <el-card class="box-card" style="height: 100%">
      <div slot="header" class="clearfix">
        <span>{{ name }}</span>
      </div>
      <div class="text item">
        <div class="tab">
          <el-tag class="tag" :effect="weekEffect" type="warning" @click="initData('week')">最近一个周</el-tag>
          <el-tag class="tag" :effect="mouthEffect" type="success" @click="initData('mouth')">最近一个月</el-tag>
          <!-- <el-tag
            class="tag"
            :effect="quarterEffect"
            type="info"
            @click="initData('quarter')"
            >最近一个季度</el-tag
          > -->
          <el-tag class="tag" :effect="yearEffect" type="warning" @click="initData('year')">最近一个年</el-tag>
        </div>
        <div id="platDiagnosis" style="width: 100%; height: 380px"></div>
      </div>
    </el-card>
  </div>
</template>

<script>
import echarts from "echarts";
import { getIndexTotal, getIndexMy } from "@/api";
export default {
  props: {
    name: String,
  },
  data() {
    return {
      eTimeVal: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      eDataVal: [820, 932, 901, 934, 1290, 1330, 1320],
      mouthEffect: "plain",
      quarterEffect: "plain",
      yearEffect: "plain",
      weekEffect: "plain",
      myEchart: "",
    };
  },
  mounted() {
    this.myEchart = echarts.init(document.getElementById("platDiagnosis"));
    this.initData("week");
  },
  methods: {
    resize() {
      this.myEchart.resize();
    },
    reastData() {
      this.mouthEffect = "plain";
      this.quarterEffect = "plain";
      this.yearEffect = "plain";
      this.weekEffect = "plain";
    },
    //数据初始化
    async initData(type) {
      await this.reastData();
      var cur = type + "Effect";
      this[cur] = "dark";

      let data = {
        week: type === "week" ? 1 : 0,
        year: type === "year" ? 1 : 0,
        // quarter: type === "quarter" ? 1 : 0,
        mouth: type === "mouth" ? 1 : 0,
        pharmacistId: "",
        userType: "1",
      };
      let res = await getIndexMy(data);
      if (res.success) {
        res.result.name = this.setDateType(type);
        this.initEcharts(res.result);
      }
    },
    setDateType(type) {
      // switch (type) {
      //   case "week":
      //     return "周";
      //     break;
      //   case "mouth":
      //     return "月";
      //     break;
      //   case "quarter":
      //     return "季";
      //     break;
      //   case "year":
      //     return "年";
      //     break;
      // }
    },
    initEcharts(total) {
      let option = {
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: total.eTimeVal,
          name: total.name,
        },
        yAxis: {
          type: "value",
          name: "个",
        },
        series: [
          {
            data: total.eDataVal,
            type: "line",
            areaStyle: {},
          },
        ],
      };
      this.myEchart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-tabs__item:hover {
  // color: rgb(73, 178, 82);
  color: #fc9710 !important;
}

.el-tabs__item.is-active {
  color: #fc9710 !important;
}

.el-tabs__active-bar {
  background-color: #fc9710 !important;
}
.tab {
  text-align: right;
  .tag {
    cursor: pointer;
  }
}
.platDiagnosis {
  height: 100%;
  .text {
    height: 100%;
  }
}
</style>
